exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".aboutHeader {\n  background-color: #5472A0;\n  color: #1A2844;\n}\n\n.aboutContent, .aboutTitle {\n  text-align: left;\n}\n\n.aboutBack {\n  background-color: #1F232A;\n}\n\n.aboutBack h1, .aboutBack p{\n  color: white;\n}\n\n.aboutBack h4 {\n  color: #5472A0;\n}\n\n.aboutBack li {\n  color: white;\n}\n", ""]);

// exports
